import { Injectable } from '@angular/core';
// import { Currency } from '@models/currency';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class Type22Service {

//   public currencys: Currency[] = [];
  private typePlazo = new BehaviorSubject<number>(0);
  public customOption = this.typePlazo.asObservable();
  constructor() {}
  public changeOption(id:number): void {
    this.typePlazo.next(Number(id));
  }
  public getOption() {
    return this.typePlazo
  }
//   public setCurrency(currencies: Currency[]) {
//     this.currencys = currencies
//   }
//   public getSymbol() {
//     return this.currencys.find(el => el.id === this.typePlazo.value)
//   }
}
